  <template>
    <div class="wrapper hotels-info-with-filtering flex"
        data-hotel-filtering data-filterable-wrap
        :data-mobile-filter-link-text="$t('commons.msg_filters')"
        data-show-map-tab="true"
        :data-hotels-id="`${hotelsFiltered.map(hotel => 'h'+hotel.id)}`"
        :data-all-hotels-id="`${hotels.map(hotel => 'h'+hotel.id)}`">
        <template v-if="isMobile">
          <div id="mobile-filter-panel"
              class="mobile-panel filters-panel right ready"
              :class="{opened: toggleFiltersView}">
            <p class="panel-title">{{$t('commons.msg_filters')}}</p>
            <FiltersSidebar
              :filters="filters"
              :selectedFilters="selectedFilters"
              v-on:resetFilters="resetFilters()"
              :displayButtonFilters="displayButtonFilters"
              v-on:filter-checked-checkbox="updateCheckboxFilters($event)"
              v-on:filter-checked-all="updateCheckboxAll($event)"
              v-on:toggleFilters="toggleFilters()"

            />
            <a href="#" class="apply-btn close-mobile-panel hide-in-app" @click="toggleFilters()" data-close-panel=""><span class="s s-close-fat"></span></a>
          </div>
          <div id="mobile-filter-panel-order"
            class="mobile-panel filters-panel right ready"
            :class="{opened: toggleOrderView}"
            data-mobile-panel
            panel-option="" data-inline="">
            <p class="panel-title">{{$t('commons.order_by')}}</p>
            <div id="order-list" class="formz" data-current-order="ascending_price" data-panel-option-list=""
              data-trigger-click="data-root-destination">
              <input type="radio" name="[filter_order]" id="ascending_price_panel" value="ascending_price" @click="sortBy('tcl_price', 'asc')" />
              <label class="t-p label-col" for="ascending_price_panel" @click="sortBy('tcl_price', 'asc')">{{$t('commons.ascending_price')}}</label><br>
              <input type="radio" name="[filter_order]" id="descending_price_panel" value="descending_price" @click="sortBy('tcl_price', 'desc')" />
              <label class="t-p label-col" for="descending_price_panel" @click="sortBy('tcl_price', 'desc')">{{$t('commons.descending_price')}}</label><br>
              <input type="radio" name="[filter_order]" id="alphabetical_order_down_panel" value="alphabetical_order_down" @click="sortBy('title', 'asc')" />
              <label class="t-p label-col" for="alphabetical_order_down_panel"  @click="sortBy('title', 'asc')" >{{$t('commons.alphabetical_order')}} (A-Z)</label><br>
              <input type="radio" name="[filter_order]" id="alphabetical_order_up_panel" value="alphabetical_order_up" @click="sortBy('title', 'desc')" />
              <label class="t-p label-col" for="alphabetical_order_up_panel" @click="sortBy('title', 'desc')">{{$t('commons.alphabetical_order')}} (Z-A)</label><br>
              <input type="radio" name="[filter_order]" id="category_panel" value="category" @click="sortBy('categories', 'asc')" />
              <label class="t-p label-col" for="category_panel" @click="sortBy('categories', 'asc')">{{$t('commons.category')}}</label><br>
            </div>
            <div class="footer-buttons mobile-only">
              <a class="secondary-btn apply-filters" @click="toggleOrder()" href="#">{{$t('commons.apply_filters')}}</a>
              <a class="secondary-btn close-filters show-in-app" @click="toggleOrder()" data-close-panel href="#">{{$t('commons.close_filters')}}</a>
            </div>
            <a href="#" class="apply-btn close-mobile-panel hide-in-app" @click="toggleOrder()"><span class="s s-close-fat"></span></a>
          </div>
        </template>
        <FiltersSidebar v-else
          :filters="filters"
          :selectedFilters="selectedFilters"
          :displayButtonFilters="true"
          v-on:resetFilters="resetFilters()"
          v-on:filter-checked-radio="updateRadioFilters($event)"
          v-on:filter-checked-checkbox="updateCheckboxFilters($event)"
          v-on:filter-checked-all="updateCheckboxAll($event)"
        />
        <HotelList :hotels="hotelsFiltered"
          :filters="filters"
          v-on:toggle-filters="toggleFilters()"
          v-on:resetFilters="resetFilters()"
          v-on:filter-checked-radio="updateRadioFilters($event)"
          v-on:filter-checked-checkbox="updateCheckboxFilters($event)"
        />
        </div>
  </template>

  <script>
  import Vue from 'vue'
  import FiltersSidebar from '../components/FiltersSidebar.vue';
  import HotelList from '../components/HotelList.vue';
  import * as _ from 'lodash';

  export default {
    name: 'HotelsInfoWithFiltering',
    components: {
      FiltersSidebar,
      HotelList
    },
    props: ['showHotels', 'rawData', 'offerPage'],
    data() {
      return {
        toggleFiltersView: false,
        toggleOrderView: false,
        orderHotels: false,
        orderDetails: {},
        selectedFilters: {
          all_countries: false,
          all_zones: false,
          categories: [],
          countries: [],
          features: [],
          nst: [],
          specialties: [],
          zones: []
        }
      }
    },
    mounted() {
      let vm = this;


      /**
        * Select and activate Zone's radio from the user market
      */

      if (localStorage.zone) {
        this.selectedFilters.zones.push(parseInt(localStorage.zone));
        localStorage.removeItem('zone');
      } else {
        // Se deja comentado por petición del ticket: PY04777-222
        // this.filtersRaw.zones.map(item => item.id).forEach(i => this.selectedFilters.zones.push(i));
        // this.selectedFilters.all_zones = true;
      }

      if (localStorage.country) {
        this.selectedFilters.countries.push(parseInt(localStorage.country));
        localStorage.removeItem('country');
      }

      if(!this.offerPage) {
        this.selectedFilters.nst.push(1);
      }

      if (localStorage.nst) {
        localStorage.removeItem('nst');
      }

      this.selectedFilters = {
        ...this.selectedFilters,
        countries: this.selectedFilters.countries,
        zones: this.selectedFilters.zones
      }
      this.sortBy('tcl_price', 'asc');
      IB.utag_eec_events.product_impressions_search();

    },

    updated: function () {
      this.$nextTick(function () {
        if ($('#hotels-filter-map').is(':visible')) IB.hotels_filter_map.filterVisible();
      })
    },
    methods: {
      /**
        * Get the response of the api and map hotels
        * @return: Array
        * @param: response: Object
      */
      mapHotels: function(response) {
        return response.hotels.reduce((acc, hotel) => {
          if ((hotel.mib_price && hotel.tcl_price) || (hotel.next_opening)) {
            acc.push({
              id: hotel.id,
              city: hotel.city,
              title: hotel.title,
              countries: [ hotel.country_id ],
              hotel_segmentation: hotel.hotel_segmentation,
              price_board: hotel.price_board,
              zones: hotel.destination_ancestor_ids,
              nst: hotel.the_club,
              features: hotel.overview_features_ids,
              specialties: hotel.hotel_specialty_ids,
              destination_id: hotel.destination_id,
              categories: [ hotel.hotel_category ],
              images: hotel.images,
              hotel_badges: hotel.hotel_badges,
              lat: hotel.lat,
              lng: hotel.lng,
              gmaps_zoom: hotel.gmaps_zoom,
              mib_price: hotel.next_opening || hotel.mib_price.amount,
              mib_price_html: hotel.next_opening || hotel.mib_price.html_amount,
              mib_currency: hotel.next_opening || hotel.mib_price.currency_code,
              tcl_price: hotel.next_opening || hotel.tcl_price.amount,
              tcl_price_html: hotel.next_opening || hotel.tcl_price.html_amount,
              tcl_currency: hotel.next_opening || hotel.mib_price.currency_code,
              url: hotel.url,
              hotel_dates: response.default_dates,
              next_opening: hotel.next_opening,
              next_opening_date: hotel.next_opening_date,
              data_eec: hotel.data_eec,
              is_rose_gold: hotel.is_rose_gold,
              hotel_segmentations: hotel.hotel_segmentations,
              hotel_subsegmentations: hotel.hotel_subsegmentations
            })
          }
          return acc
        }, [])
      },
      /**
        * Extract all countries from Continents-zones to easy access
        * Continents-zones >> Countries >> Destinations >> Hotels
        * and generate custom model for Filter zone
        * @return: Array
        * @param: zonesData: Array
      */
      getCountriesFromZones: function(zonesData) {
        return zonesData.reduce((acc, zone) => {
          acc.push(...this.mapFilter(zone.children, 'country_id'))
          return acc
        }, [])
      },
      /**
        * Generate custom model for Categories Filter
        * @return: Array
        * @param:  Categories: Array
      */
      mapCategories: function(categories) {
        return categories.sort((a,b) => b - a).map(category => ({
          id: category,
          label: {
            es: category,
            en: category,
            de: category,
            pt: category,
            fr: category,
            utag: category.replace('*','')
          },
          disabled: false,
          checked: false
        }))
      },
      /**
        * Generate custom model for Filter
        * @return: Array
        * @param:  filters: Array, idKey: String, isZones: Boolean
      */
      mapFilter: function(filters, idKey = 'id', isZones) {
        return filters.map(filter => ({
          id: filter[idKey],
          zone: filter.parent_id,
          label: {
            es: filter.title_es,
            en: filter.title_en.replace('-',' '),
            de: filter.title_de,
            fr: filter.title_fr,
            pt: filter.title_pt,
          },
          klass: filter.klass,
          disabled: false,
          checked: false
        }))
      },
      /**
        * function that updates the radios, It receives a event with the next format. Deprecated
        * @param: event: Object ({ name:'zones', value: Number })
      */
      updateRadioFilters: function(event) {
        Vue.set(this.selectedFilters, event.name, [event.value])
        this.filters[event.name]
          .filter(filter => filter.id != event.value).length
        && this.filters[event.name]
          .filter(filter => filter.id != event.value)
            .forEach(filter => filter.checked = false)
        this.filters[event.name].find(filter => filter.id == event.value).checked = true
        if (event.name === 'zones') {
          this.selectedFilters = {
            ...this.selectedFilters,
            'categories': [],
            'specialties': [],
            'countries': [],
            'features': [],
            'all': false
          }
        }
      },
      /**
        * Function that updates the checkboxes. It receives a event with the next format
        * @param: event: Object ( { name: String, value: String || Number, event: {target: { checked: Boolean } } } )
      */
      updateCheckboxFilters: function(event) {
        if (event.event.target.checked) {
          this.selectedFilters[event.name].push(event.value)
          this.selectedFilters[event.name] = _.uniq(this.selectedFilters[event.name])
          this.selectedFilters['all_' + event.name] = false
        } else {
          this.selectedFilters[event.name] = this.selectedFilters[event.name].filter(id => id != event.value)
          this.selectedFilters['all_' + event.name] = false

          if (event.name === 'zones') {
            var zone_id = this.filters.zones.filter(z => z.id === event.value)[0].id
            var countries_to_remove = this.filters.countries.filter(c => c.zone == zone_id).map(c => c.id)
            this.selectedFilters.countries = this.selectedFilters.countries.filter(c => !countries_to_remove.includes(c));

            this.selectedFilters.all_countries = false
          } else if (event.name === 'countries') {
            var zone_id = this.filters.countries.filter(z => z.id === event.value)[0].zone
            this.selectedFilters.zones = this.selectedFilters.zones.filter(c => c != zone_id);

            this.selectedFilters.all_zones = false
          }
        }
      },
      /**
        * Function that marks/dismarks the all checkboxes
        * @param: event: Object ( { name:'countries', event: Event, parent_ids: Array } )
      */
      updateCheckboxAll: function(event){
        if (event.event.target.checked) {
          let allIds = []
          if (event.parent_ids) {
            allIds = this.filtersRaw[event.name].map(item => {
              if (event.parent_ids.includes(item.zone) ){
                return item.id
              }
            })
          } else {
            allIds = this.filtersRaw[event.name].map(item => item.id)
          }
          this.selectedFilters[event.name].push(...allIds)
        } else {
          this.selectedFilters[event.name] = []
        }
        this.selectedFilters['all_' + event.name] = this.selectedFilters[event.name].length > 0
      },
      /**
        * Filter Filters based on the difference
        * @return: Array
        * @param: filter: Array, filterProp: String
      */
      filterDifference: function(filter, filterProp) {
        return this.selectedFilters[filterProp].length
          ? filter.filter(hotel => _.difference(this.selectedFilters[filterProp], hotel[filterProp]).length === 0 )
          : filter
      },
      /**
        * Filter Filters based on the intersection of difetent ID's
        * @return: Array
        * @param: filter: Array, filterProp: String
      */
      filterIntersection: function(filter, filterProp) {
        return this.selectedFilters[filterProp].length
          ? filter.filter(hotel => _.intersection(this.selectedFilters[filterProp], hotel[filterProp]).length)
          : filter
      },
      /**
        * Reset Filters to initial state
      */
      resetFilters: function() {
        IB.utag_filters.clear_all();
        this.selectedFilters = {
          ...this.selectedFilters,
          nst: [],
          zones: [],
          categories: [],
          specialties: [],
          countries: [],
          features: [],
          all_zones: false,
          all_countries: false
        }
      },
      /**
        * Get a filter array and modify it's state (checked, disabled hotelNumber)
        * @return: Object
        * @param: _this: this, filterName: String
      */
      modifyFilterItem: function( _this, filterName) {
        return {
          [filterName]: _this.filtersRaw[filterName].map(filter => ({
            ...filter,
            checked: _this.selectedFilters[filterName].find(f => f == filter.id),
            disabled: _this.hotelsFiltered.filter(h => h[filterName].includes(filter.id)).length === 0,
            hotels: _this.hotelsFiltered.filter(h => h[filterName].includes(filter.id)).length
          })),
        }
      },
      /**
        * Toggle Filter Panel on mobile
      */
      toggleFilters: function() {
        this.toggleFiltersView = !this.toggleFiltersView
      },
      /**
        * Toggle Order Panel on mobile
      */
      toggleOrder: function() {
        this.toggleOrderView = !this.toggleOrderView
      },
      /**
        * Sort Hotel List based on a property and a direction
        * prop: String, direction: String
      */
      sortBy: function(prop, direction) {
        this.orderHotels = true;
        this.orderDetails = {
          prop,
          direction
        }
      }
    },
    computed: {
      /**
        * Create Hotels Array based on rawData
        * @return Array
      */
      hotels: function() {
        return this.mapHotels(this.rawData)
      },
      /**
        * Create Filters Object based on rawData
        * @return Object
      */
      filtersRaw: function() {
        return  {
          'zones': this.mapFilter(this.rawData.zones, 'id', true),
          'countries': this.getCountriesFromZones(this.rawData.zones),
          'categories': this.mapCategories(this.rawData.categories),
          'features': this.mapFilter(this.rawData.overview_features),
          'specialties': this.mapFilter(this.rawData.specialties),
          'nst': [
            {
              id: 1,
              label: {
                es: 'Hoteles Iberostar The Club',
                en: 'Iberostar The Club Hotels',
                de: 'Iberostar The Club Hotels',
                pt: 'Iberostar The Club Hotels',
                fr: 'Iberostar The Club Hotels',
              },
              checked: false,
              disabled: false
            }
          ]
        }
      },
      /**
        * Listado de hoteles Filtrado
        * @return Array
      */
      hotelsFiltered: function() {
        let _this = this
        return this.hasFiltersSelected || this.isMobile
          ? this.orderHotels
            ? _.chain(this.hotels)
                .thru(hotels => this.selectedFilters.nst.length ? hotels.filter(hotel => hotel.nst) : hotels)
                .thru(hotels => this.filterIntersection(hotels, 'countries'))
                .thru(hotels => this.filterIntersection(hotels, 'zones'))
                .thru(hotels => this.filterDifference(hotels, 'categories'))
                .thru(hotels => this.filterDifference(hotels, 'features'))
                .thru(hotels => this.filterDifference(hotels, 'specialties'))
                .thru(hotels => _.orderBy(hotels, [(o) => +o[_this.orderDetails.prop]], [_this.orderDetails.direction]))
                .value()
            : _.chain(this.hotels)
                .thru(hotels => this.selectedFilters.nst.length ? hotels.filter(hotel => hotel.nst) : hotels)
                .thru(hotels => this.filterIntersection(hotels, 'countries'))
                .thru(hotels => this.filterIntersection(hotels, 'zones'))
                .thru(hotels => this.filterDifference(hotels, 'categories'))
                .thru(hotels => this.filterDifference(hotels, 'features'))
                .thru(hotels => this.filterDifference(hotels, 'specialties'))
                .value()
        : this.hotels;
      },
      /**
        * Listado de filtros Actualizado con el número de hoteles, y su estado de check y disabled.
        * @return Object
      */
      filters: function () {
        let _this = this
        return this.showHotels ? {
          ..._this.filtersRaw,
          nst: _this.filtersRaw.nst.map(item => ({
            ...item,
            checked: _this.selectedFilters.nst.find(f => f == item.id),
            hotels: _this.hotelsFiltered.filter(h => h.nst).length
          })),
          zones: _this.filtersRaw.zones.map(zone => ({
            ...zone,
            checked: _this.selectedFilters.zones.find(f => f == zone.id),
            hotels: _this.hotelsFiltered.filter(h => h.zones.includes(zone.id)).length
          })),
          countries: _this.filtersRaw.countries.reduce((acc, country) => {
            /**
             * Avoid showing countries without hotels.
            */
            if(_this.hotels.filter(h => h.countries.includes(country.id)).length > 0) {
              acc.push({
                ...country,
                checked: _this.selectedFilters.countries.find(f => f == country.id),
                hotels: _this.hotels.filter(h => h.countries.includes(country.id)).length
              })
            }
            return acc
          }, []),
          ...this.modifyFilterItem(_this, 'categories'),
          ...this.modifyFilterItem(_this, 'specialties'),
          ...this.modifyFilterItem(_this, 'features'),
        }
        : this.filtersRaw
      },
      /**
        * Return mobile if mq is mobile
        * @return Boolean
      */
      isMobile: function() {
        return MQBE.current_state() === 'mobile'
      },
      /**
        * Calulate wheteher or not the bottom-actions block has to be shown
        * @return Boolean
      */
      displayButtonFilters: function () {
        return this.isMobile && this.hasFiltersSelected
      },
      /**
        * Check if any filter is selected.
        * In case of mobile we need to fake that no zone is selected so the buttons
        * of the filters appear even if no one clicks a filter
        * @return Boolean
      */
      hasFiltersSelected: function() {
        return  this.selectedFilters.zones.length > 0
               || this.selectedFilters.categories.length > 0
               || this.selectedFilters.countries.length > 0
               || this.selectedFilters.features.length > 0
               || this.selectedFilters.specialties.length > 0
               || this.selectedFilters.nst.length > 0
      },
    }

  }

  </script>
